import {EnvironmentProviders, inject, Injectable, makeEnvironmentProviders} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Title} from '@angular/platform-browser';
import {RouterStateSnapshot, TitleStrategy} from '@angular/router';
import {Store} from '@ngrx/store';
import {OrganizationSelectors} from '@store/organization/organization.selectors';
import {BehaviorSubject, combineLatest} from 'rxjs';

@Injectable({providedIn: 'root'})
export class PhoenixTitleStrategy extends TitleStrategy {
  private readonly title: Title = inject(Title);
  private readonly store: Store = inject(Store);
  private readonly pageTitle: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);

  constructor() {
    super();

    combineLatest([this.pageTitle, this.store.select(OrganizationSelectors.Auth.name)]).pipe(
      takeUntilDestroyed()
    ).subscribe(([pageTitle, libraryName]) => {
      const displayName: string = libraryName.trim() || 'Library Catalog';
      this.title.setTitle(pageTitle ? `${pageTitle} - ${displayName}` : displayName);
    });
  }

  public override updateTitle(snapshot: RouterStateSnapshot): void {
    this.pageTitle.next(this.buildTitle(snapshot));
  }
}

export function providePhoenixTitleStrategy(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {provide: TitleStrategy, useClass: PhoenixTitleStrategy}
  ]);
}
